import { render, staticRenderFns } from "./VideoPlayer.pug?vue&type=template&id=16bcb1aa&scoped=true&lang=pug&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.scss?vue&type=style&index=0&id=16bcb1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bcb1aa",
  null
  
)

export default component.exports